import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const FormFieldStyled = styled(Box, {
  mb: '$6',
});
